<template>
    <div>
        <crud-table :actions="actions" show-search hide-create :search-placeholder="'ابحث برقم الجلسة أو (ناجح) أو (راسب)'" server-pagination :page-count="sessions.meta.last_page" :current-page="sessions.meta.current_page" :total="sessions.meta.total" :per-page="sessions.meta.per_page" :title="title" :items="sessionsItemsComputed" :headers="headers" @load="loadMore" @details="openSessionDialog" @autocorrect="openAutoCorrectDialog" @delete="openDeleteDialog" @search="search" @reset="reset">
            <template slot="header-actions">
                <div>
                    <v-tooltip v-if="exam_id" transition="fade-transition" bottom max-width="280" color="tooltip" :close-delay="300" open-on-focus>
                        <template v-slot:activator="{on, attrs}">
                            <v-btn :disabled="!sessionsItems || sessionsItems.length === 0" color="success darken-1" depressed v-on="on" v-bind="attrs" @click="exportDialog = true" style="height: 38px" class="ms-lg-4">
                                <v-icon size="22" left>mdi-file-export-outline</v-icon>
                                <span>استخراج</span>
                            </v-btn>
                        </template>
                        <span>استخراج إلى ملف إكسيل</span>
                    </v-tooltip>
                </div>
            </template>
        </crud-table>


        <action-dialog v-model="autoCorrectDialog" :disabled="autoCorrectItem && autoCorrectItem.requires_manual_correction" max-width="425" action="post" :url="`/exams/sessions/${autoCorrectItem ? autoCorrectItem.id : ''}/autocorrection`" success-msg="تم التصحيح الآلي بنجاح" title="التصحيح الآلي للامتحان" :subtitle="`التصحيح الآلي لجلسة امتحان الطالب (${autoCorrectItem ? autoCorrectItem.user.name : ''})`" button-text="تأكيد العملية" button-color="success darken-1" @sync="syncItem">
            <div v-if="autoCorrectItem && autoCorrectItem.requires_manual_correction">
                <v-alert icon="mdi-alert-circle" color="blue-grey" small dense text outlined>
                    <span class="details-text strong-text--text">لا يمكن التصحيح الآلي لوجود إجابات تحتاج للتصحيح اليدوي</span>
                </v-alert>
            </div>
            <div v-else class="medium-text text--text">
                <b class="strong-text--text">تأكد من النقاط التالية قبل التصحيح:</b>

                <div>
                    <ul style="margin: 0.5rem 1.5rem 0.5rem 0; line-height: 1.7rem">
                        <li>لم تتغير الدرجة الكلية للامتحان عن وقت امتحان الطالب</li>
                        <li>لم يتغير توزيع الدرجات (درجة كل سؤال) عن التوزيع وقت امتحان الطالب</li>
                    </ul>
                </div>
            </div>
        </action-dialog>

        <v-dialog v-model="sessionDetailsDialog" max-width="450" overlay-color="#000" overlay-opacity="0.8" :fullscreen="phoneOnly" >

            <v-card v-if="sessionDetailsItem" :class="{'fill-height': phoneOnly}">
                <v-card-title>نتيجة الامتحان</v-card-title>
                <v-card-subtitle>تفاصيل أكتر عن الجلسة والتصحيح اﻹلكتروني</v-card-subtitle>
                <v-card-text>
                    <v-btn absolute top left icon color="muted" @click="sessionDetailsDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-alert v-if="!sessionDetailsItem.succeeded" dense text type="error" icon="mdi-alert-decagram">
                        <b>راسب </b>
                        <span class="error-text--text ms-2 medium-text">
                            لم يتمكن من اجتياز الامتحان،
                            <span v-if="sessionDetailsItem.correction_percentage"> النسبة المئوية <b>{{sessionDetailsItem.correction_percentage}}%</b></span>
                        </span>
                    </v-alert>
                    <v-alert v-else dense text type="success" icon="mdi-check-decagram">
                        <b class="success--text text--darken-1">ناجح!</b>
                        <span class="success-text--text ms-4 medium-text">
                            اجتاز الطالب الامتحان بنجاح
                            <span v-if="sessionDetailsItem.correction_percentage">بنسبة <b>{{sessionDetailsItem.correction_percentage}}%</b></span>
                        </span>
                    </v-alert>
                    <v-list two-line class="ma-0 pa-0">
                        <v-list-item v-if="sessionDetailsItem.correction_mark || sessionDetailsItem.correction_mark === 0">
                            <v-list-item-icon>
                                <v-icon color="strong-text">mdi-license</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content style="max-width: 50px; text-align: center">
                                <v-list-item-title class="font-weight-bold">{{sessionDetailsItem.correction_mark}}</v-list-item-title>
                                <v-divider style="border-width: 1px"></v-divider>
                                <v-list-item-subtitle class="strong-text--text">{{sessionDetailsItem.total_mark}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="sessionDetailsItem.correct_answer_attempts || sessionDetailsItem.correct_answer_attempts === 0">
                            <v-list-item-icon>
                                <v-icon :color="sessionDetailsItem.succeeded ? 'success' : 'strong-text'">mdi-checkbox-multiple-marked-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-subtitle>عدد اﻹجابات الصحيحة</v-list-item-subtitle>
                                <v-list-item-title style="font-weight: 600">{{sessionDetailsItem.correct_answer_attempts}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="sessionDetailsItem.wrong_answer_attempts || sessionDetailsItem.wrong_answer_attempts === 0">
                            <v-list-item-icon>
                                <v-icon :color="sessionDetailsItem.wrong_answer_attempts ? 'error' : 'muted'">mdi-close-box-multiple-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-subtitle>عدد اﻹجابات الخاطئة</v-list-item-subtitle>
                                <v-list-item-title style="font-weight: 600">{{sessionDetailsItem.wrong_answer_attempts}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="sessionDetailsItem.answer_attempts_count || sessionDetailsItem.answer_attempts_count === 0">
                            <v-list-item-icon>
                                <v-icon color="text">mdi-radiobox-marked</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-subtitle>عدد اﻷسئلة المجاب عنها</v-list-item-subtitle>
                                <v-list-item-title style="font-weight: 600">{{sessionDetailsItem.answer_attempts_count}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="sessionDetailsItem.time_taken && sessionDetailsItem.submitted_at">
                            <v-list-item-icon>
                                <v-icon color="indigo darken-1">mdi-clock-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-subtitle>الوقت المستغرق</v-list-item-subtitle>
                                <v-list-item-title style="font-weight: 600">{{this.formatSeconds(sessionDetailsItem.time_taken)}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider inset></v-divider>

                        <v-list-item v-if="sessionDetailsItem.start_time">
                            <v-list-item-icon>
                                <v-icon color="text">mdi-clock-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-subtitle>وقت دخول الامتحان</v-list-item-subtitle>
                                <v-list-item-title class="ltr-dir text-right medium-text" style="font-weight: 600">{{sessionDetailsItem.start_time}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                            <v-list-item-icon>
                                <v-icon color="text">mdi-send-check</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-subtitle>وقت تسليم الامتحان</v-list-item-subtitle>
                                <v-list-item-title v-if="sessionDetailsItem.submitted_at" class="ltr-dir text-right medium-text" style="font-weight: 600">{{sessionDetailsItem.submitted_at}}</v-list-item-title>
                                <v-list-item-title v-else class="medium-text error--text">لم يتم تسليم الامتحان</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card-text>
            </v-card>

        </v-dialog>

        <v-dialog v-if="exam_id" v-model="exportDialog" max-width="320" overlay-color="#000" overlay-opacity="0.8">
            <v-card>
                <v-card-title class="strong-text--text mb-1">
                    <v-icon color="green darken-2" right>mdi-file-export-outline</v-icon>
                    استخراج نتائج الامتحان
                </v-card-title>
                <v-card-subtitle>استخراج نتائج الامتحان إلى ملف إكسيل</v-card-subtitle>
                <v-card-text class="pt-0">
                    <v-alert v-if="searchQuery" dense color="grey darken-1" text>
                        <span class="details-text">سيتم استخراج نتائج عملية البحث فقط</span> <!--  "{{searchQuery}}" -->
                    </v-alert>

                    <v-form class="mb-4">
                        <v-checkbox v-model="exportUserFullData" color="success" label="استخراج بيانات الطالب كاملة" persistent-hint hint="استخراج بيانات الطالب كاملةً وليس الاسم فقط" class="mt-0"></v-checkbox>
                        <v-checkbox v-model="showExportDates" color="success" label="تحديد فترة زمنية" persistent-hint hint="تحديد مدة زمنية (من، إلى) للبيانات المُستخرجة"></v-checkbox>
                        <template v-if="showExportDates">
                        <v-menu ref="fromDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="exportFromDate" clearable label="من يوم (اختياري)" placeholder="فلترة بدءاً من يوم (اختياري)" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details class="mb-3"></v-text-field>
                            </template>
                            <v-date-picker ref="picker" v-model="exportFromDate" locale="ar" :max="today" @change="saveFromDate" color="success"></v-date-picker>
                        </v-menu>
                        <v-menu ref="toDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="exportToDate" clearable label="إلى يوم (اختياري)" placeholder="فلترة حتى يوم (اختياري)" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details class="mb-3"></v-text-field>
                            </template>
                            <v-date-picker ref="picker" v-model="exportToDate" locale="ar" :max="today" @change="saveToDate" color="success"></v-date-picker>
                        </v-menu>
                        </template>
                    </v-form>
                </v-card-text>
                <v-card-actions class="pt-0 pb-3">
                    <form :action="`${apiUrl}/exams/sessions/export/${exam_id}`" type="POST">
                        <input type="hidden" name="api_token" :value="apiToken" />
                        <input v-if="searchQuery" type="hidden" name="query" :value="searchQuery" />
                        <input v-if="exportFromDate" type="hidden" name="from_date" :value="exportFromDate" />
                        <input v-if="exportToDate" type="hidden" name="to_date" :value="exportToDate" />
                        <input v-if="exportUserFullData" type="hidden" name="user_full_data" value="1" />
                        
                        <v-btn :disabled="!sessionsItems || sessionsItems.length === 0" block color="green darken-1" depressed dark download @click="exportDialog = false" type="submit" class="ms-auto">
                            <v-icon left>mdi-download</v-icon>
                            استخراج الملف
                        </v-btn>
                    </form>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <action-dialog v-model="deleteDialog" action="delete" :url="`/exams/sessions/${deleteSession ? deleteSession.id : ''}`" title="حذف جلسة الامتحان" button-text="تأكيد الحذف" button-color="error" @sync="deleteItem(deleteSession.id)">
            <div v-if="deleteSession">
                <p class="strong-text--text mb-0">
                    هل أنت متأكد من حذف الجلسة رقم (<b class="strong-text--text">{{deleteSession.id}}</b>) الخاصة بالطالب "{{deleteSession.user ? deleteSession.user.name : ''}}" ؟
                </p>
            </div>
        </action-dialog>
    </div>
</template>

<script>
import CrudTable from '@/components/default/crud-table'

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    components: {
        CrudTable,
    },
    props: {
        sessions: {},
        title: {},
        exam_id: {},
    },
    data() {
        const now = new Date();

        return {

            today: now.toISOString().substr(0, 10),

            searchQuery: '',
            exportUserFullData: false,
            showExportDates: false,
            exportToDate: '',
            exportFromDate: '',


            exportDialog: false,

            deleteDialog: false,
            deleteSession: null,

            sessionsItems: null,

            sessionDetailsDialog: false,
            sessionDetailsItem: null,
            
            autoCorrectDialog: false,
            autoCorrectItem: null,

            headers: [
                {
                    text: 'عمليات',
                    value: 'actions',
                    sortable: false
                },
                {
                    text: '#',
                    align: 'start',
                    sortable: false,
                    value: 'id',
                },
                {
                    text: 'الامتحان',
                    align: 'center',
                    sortable: false,
                    value: 'examName',
                    button: 'examUrl',
                    color: 'link'
                },
                {
                    text: 'اسم الطالب',
                    align: 'center',
                    sortable: false,
                    value: 'userName',
                },
                {
                    text: 'النتيجة',
                    align: 'center',
                    sortable: false,
                    value: 'isSuccessed',

                    chip: true,
                    chipFunction: (succeeded)=>{
                        if (succeeded){
                            return {text: 'ناجح', color: 'success', icon: 'mdi-check-decagram'};
                        }else if (succeeded === null){
                            return {text: 'لم يُصحّح', color: 'muted', icon: 'mdi-alert-circle-outline'};
                        }else{
                            return {text: 'راسب', color: 'error', icon: 'mdi-alert-decagram'};
                        }
                    },
                },
                {
                    text: 'درجة الطالب',
                    align: 'center',
                    sortable: false,
                    value: 'correction_mark',
                    cellClass: 'font-weight-bold primary--text',
                },
                {
                    text: 'الدرجة الكلية',
                    align: 'center',
                    sortable: false,
                    value: 'total_mark',
                    cellClass: 'font-weight-bold',
                },
                {
                    text: 'النسبة المئوية',
                    align: 'center',
                    sortable: false,
                    value: 'correctionPercent',
                    cellClass: 'font-weight-bold',
                },
                {
                    text: 'وقت البدء',
                    value: 'start_time',
                    time: true,
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'وقت التسليم',
                    value: 'submitted_at',
                    time: true,
                    align: 'center',
                    sortable: false,
                },
            ],
        }
    },
    computed: {
        apiUrl(){
            return process.env.VUE_APP_API_URL;
        },
        apiToken(){
            return window.localStorage.getItem('tK');
        },
        sessionsItemsComputed(){
            return this.sessionsItems.map(session=>{
                return {
                    ...session,
                    userName: session.user ? session.user.name : '',
                    examName: session.exam ? session.exam.name : '',
                    examUrl: session.exam ? `/exams/${session.exam.id}` : null,
                    correctionPercent: session.correction_percentage ? session.correction_percentage + '%' : '___',
                    
                    isSuccessed: session.succeeded ? true : (!session.last_corrected_at ? null : false),
                }
            });
        },
        actions(){
            let actions = [
                {name: 'details', text: 'تفاصيل النتيجة', icon: 'mdi-file-document', color: 'primary'},
                {name: 'autocorrect', text: 'التصحيح اﻵلي', icon: 'mdi-progress-check', color: 'success'},
                // {name: 'edit', text: 'تعديل', icon: 'mdi-pencil'},
                {name: 'delete', text: 'حذف', icon: 'mdi-delete', color: 'error'},
            ];
            return actions;
        },
        ...GlobalComputed,
    },
    watch: {
        sessions(sessions){
            this.sessionsItems = sessions.data;
        },
    },
    methods: {
        ...GlobalMethods,
        
        loadMore(payload){
            const page = payload.page;
            this.$emit('loadMore', page);
        },
        addItems(data){
            const items = data.data ? data.data : data;
            this.sessionsItems.unshift(...items);
        },
        search(query){
            this.$emit('search', query);
        },
        reset(){
            this.$emit('reset');
        },
        syncItem(newItem){
            this.sessionsItems = this.sessionsItems.map(item=>{
                if (item.id === newItem.id){
                    return Object.assign(item, newItem);
                }
                return item;
            })
        },
        deleteItem(id){
            this.sessionsItems = this.sessionsItems.filter(item=>{
                return item.id !== id;
            })
        },
        editAction(){

        },
        openDeleteDialog(session){
            this.deleteDialog = true;
            this.deleteSession = session;
        },
        openSessionDialog(session){
            this.sessionDetailsDialog = true;
            this.sessionDetailsItem = session;
        },
        openAutoCorrectDialog(session){
            this.autoCorrectDialog = true;
            this.autoCorrectItem = session;
        },
        checkQuery(){
            const queryParam = new URLSearchParams(window.location.search).get('query');
            if (queryParam){
                this.searchQuery = queryParam;
            }else{
                this.searchQuery = null;
            }
        },
        saveFromDate(date){
            this.$refs.fromDateMenu.save(date);
        },
        saveToDate(date){
            this.$refs.toDateMenu.save(date);
        },
        formatSeconds(seconds){
            let remaining = seconds * 1000; // in milliseconds
            if (remaining){
                // Time calculations for days, hours, minutes and seconds
                let hours = Math.floor(remaining / (1000 * 60 * 60));
                let minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
                let seconds = Math.floor((remaining % (1000 * 60)) / 1000);

                let hoursText = hours < 10 ? "0" + hours : hours;
                let minutesText = minutes < 10 ? "0" + minutes : minutes;
                let secondsText = seconds < 10 ? "0" + seconds : seconds;

                return hours ? `${hoursText}:${minutesText}:${secondsText}` : `${minutesText}:${secondsText}`;
            }else{
                return '00:00';
            }
        },
    },
    mounted(){
        this.checkQuery();
    },
    created(){
        this.sessionsItems = this.sessions.data;
    }
}

</script>
